module.exports = __webpack_public_path__ + "img/2012-12-14 20.02.42.8a3a342f.jpg";